import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { StorageNode } from './storage-node'

@Injectable({
  providedIn: 'root',
})
export class StorageNodeService extends RestClientPaged<StorageNode, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/storage/nodes', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findOne(path: string): Observable<StorageNode> {
    const params = HttpParamsBuilder.start().append('path', path).build()

    return this.http.get<StorageNode>(this.restEndpoint + '/one', { params: params })
  }
}
